import React from 'react'
import {
  NudistaBold14,
  NudistaMedium9,
  NudistaSemiBold12,
} from '../Common/Fonts'
import {
  Wrapper,
  ColumnFlexDiv,
  RowFlexDiv,
  Icon,
  UserProfilePictureHolder,
  UserProfilePicture,
  FadeInDiv,
} from './LeftNavStyles'

const LeftNav = ({ leftNavbarMinified, setLeftNavbarMinified }) => {
  const NavbarIcons = [
    { icon: '/images/navbar/menu/doc.svg', route: '/doc' },
    { icon: '/images/navbar/menu/shield.svg', route: '/shield' },
    { icon: '/images/navbar/menu/card.svg', route: '/card' },
    { icon: '/images/navbar/menu/users.svg', route: '/users' },
  ]

  return (
    <Wrapper
      onMouseEnter={() => {
        console.log(true)
        setLeftNavbarMinified(false)
      }}
      onMouseLeave={() => {
        console.log(false)
        setLeftNavbarMinified(true)
      }}
    >
      <ColumnFlexDiv alignItems='center' gap='15px'>
        <Icon
          logo
          src='/images/navbar/photoid_logo.svg'
          alt='photoid_logo.svg'
        />
        <UserProfilePictureHolder>
          <UserProfilePicture
            alt='profile-picture'
            src='/images/navbar/stock_profile.jpg'
          />
        </UserProfilePictureHolder>
        <FadeInDiv
          opacity={leftNavbarMinified ? '0' : '1'}
          height={leftNavbarMinified ? '0' : 'max-content'}
        >
          <NudistaBold14 white>Earl Randolph</NudistaBold14>
          <NudistaMedium9 white>joe@uscope.com</NudistaMedium9>
        </FadeInDiv>
        <Icon logout src='/images/navbar/off.svg' alt='logout' />
      </ColumnFlexDiv>

      <ColumnFlexDiv gap='38px'>
        {NavbarIcons?.map((value) => (
          <RowFlexDiv alignItems='center' justifyContent='center' gap='10px'>
            <Icon navbar src={value.icon} alt={value.path} />
            <FadeInDiv
              opacity={leftNavbarMinified ? '0' : '1'}
              width={leftNavbarMinified ? '0' : '100%'}
            >
              <NudistaSemiBold12 white>Label Here</NudistaSemiBold12>
            </FadeInDiv>
          </RowFlexDiv>
        ))}
      </ColumnFlexDiv>

      <ColumnFlexDiv gap='20px' alignItems='center' justifyContent='center'>
        <Icon src='/images/navbar/uscope.png' alt='uscope' />
        <Icon
          height='26px'
          width='26px'
          src='/images/navbar/bx-support.svg'
          alt='uscope'
        />
      </ColumnFlexDiv>
    </Wrapper>
  )
}

export default LeftNav
